export default {
    backend: {
        url: "https://rezerv-api.bouygues-immobilier.com"
    },
};